import { ROUTE_API_DOCUMENTS, ROUTE_FILES, ROUTE_FILE_LEGAL_DOCUMENTS } from '@klear/constants'
import { getApiOrigin } from '@klear/runtime-env'

export const FILE_DOWNLOAD_QUERY_PARAM = 'download'

export function withAttachmentDisposition(url: string): string {
  return `${url}${url.includes('?') ? '&' : '?'}${FILE_DOWNLOAD_QUERY_PARAM}=1`
}

export function encodeStorageKeyForRoute(key: string): string {
  return key
    .split('/')
    .map((segment) => encodeURIComponent(segment))
    .join('/')
}

export function buildLegalDocumentFileUrl(traderId: number | string, key: string): string {
  return `${getApiOrigin()}/api/${ROUTE_FILES}/${ROUTE_FILE_LEGAL_DOCUMENTS}/${traderId}/${encodeStorageKeyForRoute(key)}`
}

export function buildDocumentFileUrl(documentKey: string, traderId?: number | string): string {
  const query = traderId === undefined ? '' : `?traderId=${traderId}`
  return `${getApiOrigin()}/api/${ROUTE_API_DOCUMENTS}/${encodeURIComponent(documentKey)}/file${query}`
}
